<app-header sectionName="Proxies">
    @if (canEdit) {
    <button mat-flat-button (click)="openCreateDialog()">
        <mat-icon>add</mat-icon>
        Add Proxy
    </button>
    }
</app-header>

<main class="page">
    @if (usage) {
    <div class="summary-strip">
        <div class="metric">
            <span class="metric-label">Plan</span>
            <span class="metric-value">{{ usage.plan }}</span>
        </div>
        <div class="metric">
            <span class="metric-label">Remaining</span>
            <span class="metric-value" [class.low]="usageLow">{{ usage.gb_remaining }} GB</span>
        </div>
        <div class="metric">
            <span class="metric-label">Used</span>
            <span class="metric-value">{{ usage.gb_used }} / {{ usage.gb_total }} GB</span>
        </div>
        <div class="metric metric-progress">
            <span class="metric-label">{{ usage.percent_used }}% used</span>
            <mat-progress-bar mode="determinate" [value]="usage.percent_used" [color]="usageLow ? 'warn' : 'primary'"></mat-progress-bar>
        </div>
    </div>
    }

    <div class="list-toolbar">
        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="field-wide">
            <mat-label>Search</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input matInput [(ngModel)]="filterSearch" (ngModelChange)="onSearchChange()" placeholder="Address or username" />
        </mat-form-field>
    </div>

    @if (canEdit && selectedCount > 0) {
    <div class="bulk-bar">
        <mat-icon>checklist</mat-icon>
        <span><b>{{ selectedCount }}</b> selected</span>
        <span class="spacer"></span>
        <button mat-stroked-button (click)="bulkSetActive(true)">
            <mat-icon>toggle_on</mat-icon>
            Activate
        </button>
        <button mat-stroked-button (click)="bulkSetActive(false)">
            <mat-icon>toggle_off</mat-icon>
            Deactivate
        </button>
        <button mat-stroked-button color="warn" (click)="bulkDelete()">
            <mat-icon>delete</mat-icon>
            Delete
        </button>
    </div>
    }

    <div class="table-card">
    @if (loading && !proxies.length) {
    <div class="table-state">
        <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
        Loading proxies…
    </div>
    } @else if (proxies.length === 0) {
    <div class="table-state">
        <mat-icon>dns</mat-icon>
        No proxies found.
        @if (canEdit) {
        <button mat-flat-button (click)="openCreateDialog()">
            <mat-icon>add</mat-icon>
            Add Proxy
        </button>
        }
    </div>
    } @else {
    <div class="table-scroll">
        <table mat-table [dataSource]="proxies">
            <!-- Select Column -->
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox
                        [checked]="isAllSelected()"
                        [indeterminate]="isPartiallySelected()"
                        (change)="toggleAll($event.checked)"
                        aria-label="Select all proxies">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let proxy">
                    <mat-checkbox
                        [checked]="isSelected(proxy)"
                        (change)="toggleSelection(proxy, $event.checked)"
                        aria-label="Select proxy">
                    </mat-checkbox>
                </td>
            </ng-container>

            <!-- Address Column -->
            <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef>Address</th>
                <td mat-cell *matCellDef="let proxy">{{ proxy.address }}</td>
            </ng-container>

            <!-- Port Column -->
            <ng-container matColumnDef="port">
                <th mat-header-cell *matHeaderCellDef>Port</th>
                <td mat-cell *matCellDef="let proxy">{{ proxy.port }}</td>
            </ng-container>

            <!-- Username Column -->
            <ng-container matColumnDef="username">
                <th mat-header-cell *matHeaderCellDef>Username</th>
                <td mat-cell *matCellDef="let proxy">{{ proxy.username }}</td>
            </ng-container>

            <!-- Active Column -->
            <ng-container matColumnDef="active">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let proxy">
                    <mat-slide-toggle [checked]="proxy.active" [disabled]="!canEdit" (change)="toggleActive(proxy)" color="primary">
                        {{ proxy.active ? 'Active' : 'Inactive' }}
                    </mat-slide-toggle>
                </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let proxy">
                    @if (canEdit) {
                    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Actions">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="openEditDialog(proxy)">
                            <mat-icon>edit</mat-icon>
                            <span>Edit</span>
                        </button>
                        <button mat-menu-item (click)="deleteProxy(proxy)">
                            <mat-icon>delete</mat-icon>
                            <span>Delete</span>
                        </button>
                    </mat-menu>
                    }
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
    </div>


    <mat-paginator [length]="total" [pageIndex]="pageIndex" [pageSize]="pageSize"
        [pageSizeOptions]="[25, 50, 100]" (page)="onPage($event)">
    </mat-paginator>
    }
    </div>
</main>
